export default {
  params: {
    delivery_days: '1',
    delivery_date: '',
    months: '12',
    provider: '',
    warehouse:'',
    branchoffice: '',
    observation: '',
    trm_value: null,
    option:1,
  },
  ag_grid:{
    selectedTheme:'ag-theme-balham'
  },
  entries_import:[],
  products:[],
  orders_product:[],
  back_orders: [],
  sales:[],
  lines :[],
  providers: [],
  transit: [],
  orderQuantity: [],
  pdfRoute: '',
  loading:{
    preloader:false,
    products:false,
  },
  paramsquery:{
    is_customer: false,
    is_provider: false,
    is_employee: false,
    filter_customer: [],
    filter_provider: [],
    filter_employee: [],
    paginate: true,
    page: 1,
    perPage: 50,
    query: '',
    sortBy: 'id',
    sort: 'ASC',
  },
  detail_months:[],
  columns_detail_months:[],
  entraces:[],
};



// WEBPACK FOOTER //
// ./src/modules/inventory-reposition/state.js